import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Switch from "../../../Components/switch";
import MessageIcon from "../../../Assests/MSG (1).svg";
import SearchBar from "../../../Components/Searchbar";
import Avatar from "../../../Assests/avatar.svg";
import { information, getUserProfileDetails } from '../../../Services/ShowsApi';
import { API_STATUS } from '../../../utils/constant';
import { setData } from '../../../redux/userSlice';
import BeatLoader from "react-spinners/BeatLoader";
import { useNavigate } from "react-router-dom";
import { setValue,clearUserMessage, setIsChatOpen, toggleSearchPageLoad } from '../../../redux/valueSlice';
import { CometChat } from '@cometchat/chat-sdk-javascript';
import { useSnackbar } from '../../../Components/SnackbarContext';

const CommunityTop = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const user = useSelector((state) => state?.user || []);
    const value = useSelector((state) => state?.value || "");

    const {
        UserID,
        FirstName, LastName,
        Collaborate, connectionCount,
        connectionProfile,
        FacebookLink,
        InstagramLink,
        LinkedinLink,
        SpotifyLink,
        YoutubeLink,
        ProfileImageKey,
        Bio,
        Topics
    } = user || {};

    const [isOpenToCollaborate, setIsOpenToCollaborate] = useState(Collaborate === 1);
    const [searchTerm, setSearchTerm] = useState("");
    const [toggle, setToggle] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0); // 👈 new state for unread messages
    const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
    const profileMenuRef = useRef(null);

    const toggleSwitch = async () => {
        setToggle(true);

        const payload = {
            UserID: UserID,
            Collaborate: Collaborate ? false : true,
        };
        const res = await information(payload);

        if (res?.status == API_STATUS.success) {
            setToggle(false);
            setIsOpenToCollaborate(!isOpenToCollaborate);
            const { data } = await getUserProfileDetails("UserID");
            let { Data } = data?.body;
            dispatch(setData(Data));
            // Dispatch action to trigger refresh across components
            dispatch(toggleSearchPageLoad());
        }
    };

    useEffect(() => {
        setIsOpenToCollaborate(Collaborate === 1);

        // 👇 fetch unread message count
        getUnreadCount().then((count) => {
            setUnreadCount(count);
        });

        const handleClickOutside = (event) => {
            if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
                setIsProfileMenuOpen(false);
            }
        };

        if (isProfileMenuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [Collaborate,value?.isChatOpen, isProfileMenuOpen]);

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            if (!event.target.value.trim()) {
                return;
            }
            dispatch(setValue({ filterValue: event.target.value, profileSearch: true }));
        }
    };

    const handleSearhItem = () => {
        if (!searchTerm.trim()) {
            return;
        }
        dispatch(setValue({ filterValue: searchTerm, profileSearch: true }));
    };

    function UpdateLoader() {
        return (
            <div className="sweet-loading" style={{ display: "flex", alignItems: "center", gap: "1vh" }}>
                <span>Updating</span>
                <BeatLoader
                    color="rgba(41, 104, 254, 0.8)"
                    loading={true}
                    size="1.5vh"
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
            </div>
        );
    }

    function getUnreadCount() {
        return CometChat.getUnreadMessageCountForAllUsers()
            .then((messageCount) => {
                console.log("Message count received", messageCount);
                let count = 0;
                for (const userId in messageCount) {
                    if (messageCount.hasOwnProperty(userId)) {
                        count += messageCount[userId];
                    }
                }
                console.log("Total unread count:", count);
                return count;
            })
            .catch((error) => {
                console.log("Message count fetching failed with error:", error);
                return 0;
            });
    }

    const handleChatOpen=()=>{
        dispatch(clearUserMessage());
        dispatch(setIsChatOpen(true))
    }

    // Remove the handler so the profile menu does not open from this avatar
    // const handleProfileClick = (e) => {
    //     e.stopPropagation();
    //     setIsProfileMenuOpen((prev) => !prev);
    // };

    return (
        <div id='community-top_container'>
            {/* <div className='community_user'>
                <div className='community_userImg' ref={profileMenuRef}>
                    <img src={ProfileImageKey || Avatar} alt="Profile" />
                </div>
                <div className='community_userInfo'>
                    <div className='community_userInfo_name'>
                        <span>{FirstName} {LastName}</span>
                    </div>
                    <div className='community_userInfo_status'>
                        <Switch isOn={isOpenToCollaborate} toggleSwitch={toggleSwitch} />
                        <span>
                            {toggle ? <UpdateLoader /> : isOpenToCollaborate ? "Open to Collaboration" : "Closed to Collaboration"}
                        </span>
                    </div>
                </div>
            </div> */}

            {/* Remove ProfileMenu from here so it only appears from the top-right avatar */}

            <div className='community_user_searchMsg'>
                <div className='community_user_search'>
                    <SearchBar
                        placeholder="Search"
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        handleKeyDown={handleKeyDown}
                        handleSearhItem={handleSearhItem}
                        customStyles={{ height: '4.8vh' }}
                    />
                </div>
                <div className='community_user_message' onClick={handleChatOpen}>
                    <img src={MessageIcon} alt="Messages" />
                    {unreadCount > 0 &&
                        <span>{unreadCount}</span>
                    }
                </div>
            </div>
        </div>
    );
};

export default CommunityTop;
